export default "__VITE_ASSET___adDpZhD__"